import styled, { css } from "styled-components";

export const TabsNavWrapper = styled.div<{
  $canScrollLeft?: boolean;
  $canScrollRight?: boolean;
  $isDragging?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 18px;
  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  cursor: ${({ $isDragging }) => ($isDragging ? "grabbing" : "grab")};
  user-select: ${({ $isDragging }) => ($isDragging ? "none" : "auto")};

  ${({ $canScrollLeft, $canScrollRight }) => {
    if ($canScrollLeft && $canScrollRight) {
      return css`
        -webkit-mask-image: linear-gradient(
          to right,
          transparent,
          black 24px,
          black calc(100% - 24px),
          transparent 100%
        );
        mask-image: linear-gradient(
          to right,
          transparent,
          black 24px,
          black calc(100% - 24px),
          transparent 100%
        );
      `;
    }
    if ($canScrollRight) {
      return css`
        -webkit-mask-image: linear-gradient(
          to right,
          black calc(100% - 28px),
          transparent 100%
        );
        mask-image: linear-gradient(
          to right,
          black calc(100% - 28px),
          transparent 100%
        );
      `;
    }
    if ($canScrollLeft) {
      return css`
        -webkit-mask-image: linear-gradient(
          to left,
          black calc(100% - 28px),
          transparent 100%
        );
        mask-image: linear-gradient(
          to left,
          black calc(100% - 28px),
          transparent 100%
        );
      `;
    }
    return css``;
  }}

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    margin-bottom: 14px;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const TabsNavContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: max-content;
  padding: 0 2px 1px 2px;

  @media (max-width: 768px) {
    gap: 6px;
    padding: 0 4px 1px 4px;
  }
`;

export const TabNavItem = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 14px;
  background: none;
  border: none;
  border-bottom: 2px solid ${({ $active }) => ($active ? "var(--fixit)" : "transparent")};
  color: ${({ $active }) => ($active ? "var(--fixit)" : "var(--dark-gray)")};
  font-weight: ${({ $active }) => ($active ? "600" : "500")};
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  margin-bottom: -1px;
  flex-shrink: 0;

  > svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  &:hover {
    color: var(--fixit);
    background-color: rgba(152, 53, 209, 0.04);
    border-radius: 6px 6px 0 0;
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 14px;
    gap: 6px;

    > svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const TabNavLabel = styled.span`
  white-space: nowrap;
`;

export const TabBadge = styled.span<{ $variant?: "default" | "success" | "neutral" }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 7px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  background-color: ${({ $variant }) =>
    $variant === "success"
      ? "rgba(39, 174, 96, 0.12)"
      : $variant === "neutral"
      ? "rgba(0, 0, 0, 0.06)"
      : "rgba(152, 53, 209, 0.12)"};
  color: ${({ $variant }) =>
    $variant === "success"
      ? "#27ae60"
      : $variant === "neutral"
      ? "var(--gray)"
      : "var(--fixit)"};
  white-space: nowrap;
`;
